import { Card, Col, Row, Space, Spin } from 'antd';
import React from 'react';
import { Company } from '../../../models/company-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';
import UsageStatistic from './UsageStatistic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import { faUsers } from '@fortawesome/pro-regular-svg-icons';

interface UsersUsageListProps {
  company: Company | undefined;
}

export default function UsersUsage({
  company,
}: UsersUsageListProps) {
    
  const usersQ = CustomerServiceQueries.useCompanyUsageUsers(company!.id)

  if (!company)
    return null;

  return (
    <>
    <Card title={<Space><FontAwesomeIcon icon={faUsers as Icon}/> Users</Space>}>
        <Spin spinning={usersQ.isLoading}>
            
    <Row gutter={[16,16]}>
        {usersQ.data?.map( item => (
            <Col span={12}>
                <UsageStatistic item={item} />
            </Col>
        ))}
    </Row>
        </Spin>
    </Card>
    </>
  );
}
